import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalLockComponent } from './modal-lock.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { AppTranslate, HttpLoaderFactory } from '../../app.translate';

@NgModule({
  imports: [
    CommonModule,
    ModalModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })],
  providers: [TranslateService],
  exports: [ModalLockComponent],
  declarations: [ModalLockComponent]
})
export class ModalLockModule extends AppTranslate {
  constructor(translate: TranslateService) {
    super(translate);
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/modal-lock/modal-lock.module.ts